import { useEffect, useState } from 'react';
import { tokens } from '../../theme';
import { creatorApi, type CreatorCampaign } from '../../lib/api';
import { Button } from '../../components/Button';

export function CampaignsTab() {
  const [items, setItems] = useState<CreatorCampaign[] | null>(null);
  const [claimed, setClaimed] = useState<Record<string, string>>({}); // campaignId -> serial

  useEffect(() => { creatorApi.campaigns().then((d) => setItems(d.campaigns)).catch(() => setItems([])); }, []);

  async function claim(id: string) {
    try {
      const r = await creatorApi.claim(id);
      if (r.ok) setClaimed((m) => ({ ...m, [id]: r.serial_code }));
    } catch { /* surfaced via disabled state; keep simple for v1 */ }
  }

  if (!items) return <p style={{ color: tokens.color.ink[500] }}>Loading campaigns...</p>;
  if (items.length === 0) return <p style={{ color: tokens.color.ink[500] }}>No active campaigns right now. Check back soon.</p>;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px,1fr))', gap: 16 }}>
      {items.map((c) => (
        <div key={c.id} style={{ background: tokens.color.paper['00'], border: `1px solid ${tokens.color.line[100]}`, borderRadius: 12, padding: 20 }}>
          <div style={{ fontFamily: tokens.font.mono, fontSize: 11, letterSpacing: '0.1em', color: tokens.color.ink[500], textTransform: 'uppercase' }}>{c.brand_name ?? 'Brand'}</div>
          <div style={{ fontFamily: tokens.font.display, fontWeight: 600, fontSize: 20, marginTop: 4 }}>{c.title}</div>
          <div style={{ marginTop: 8, fontSize: 13, color: tokens.color.ink[700], minHeight: 36 }}>{(c.brief ?? '').slice(0, 120)}</div>
          <div style={{ marginTop: 12, display: 'flex', gap: 16, fontFamily: tokens.font.mono, fontSize: 12, color: tokens.color.ink[700] }}>
            {c.cpm_rate != null && <span>${c.cpm_rate.toFixed(2)} CPM</span>}
            {c.ends_at && <span>ends {c.ends_at.slice(0, 10)}</span>}
          </div>
          {c.source_video_url && (
            <a href={c.source_video_url} target="_blank" rel="noreferrer" style={{ display: 'inline-block', marginTop: 8, fontSize: 12, color: tokens.color.ink[500], textDecoration: 'underline' }}>source video</a>
          )}
          <div style={{ marginTop: 16 }}>
            {claimed[c.id] ? (
              <div style={{ fontFamily: tokens.font.mono, fontSize: 13 }}>
                Claimed. Put <b style={{ color: tokens.color.accent.sage }}>{claimed[c.id]}</b> in your post, then submit the URL under <b>My Clips</b>.
              </div>
            ) : (
              <Button size="sm" onClick={() => claim(c.id)}>Claim to clip</Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
